// Mock data for Addiction Rehab Call directory
export const mockFacilities = [
  {
    id: "1",
    name: "Hazelden Betty Ford Foundation – Center City",
    city: "Center City", 
    state: "MN",
    stateFullName: "Minnesota",
    website: "https://www.hazeldenbettyford.org/locations/center-city",
    phone: "(855) 347-3292",
    email: "info@hazeldenbettyford.org",
    address: "15251 Pleasant Valley Road, Center City, MN 55012",
    treatmentTypes: ["Inpatient", "Outpatient", "Detox", "Residential"],
    specializations: ["Alcohol Addiction", "Drug Addiction", "Dual Diagnosis", "Executive Treatment"],
    insurance: ["Aetna", "Blue Cross Blue Shield", "Cigna", "United Healthcare", "Medicare", "Medicaid"],
    description: "Comprehensive addiction treatment with evidence-based therapies and personalized care plans.",
    rating: 4.8,
    reviews: 342,
    established: "1949",
    accreditation: ["Joint Commission", "CARF"],
    features: ["24/7 Medical Support", "Family Program", "Aftercare Planning", "Gender-Specific Programs"]
  },
  {
    id: "2", 
    name: "Hazelden Betty Ford – Rancho Mirage",
    city: "Rancho Mirage",
    state: "CA", 
    stateFullName: "California",
    website: "https://www.hazeldenbettyford.org/locations/rancho-mirage",
    phone: "(855) 347-3292",
    email: "admissions.rm@hazeldenbettyford.org",
    address: "39000 Bob Hope Drive, Rancho Mirage, CA 92270",
    treatmentTypes: ["Inpatient", "Outpatient", "Intensive Outpatient", "Partial Hospitalization"],
    specializations: ["Alcohol Addiction", "Prescription Drug Abuse", "Co-occurring Disorders", "Young Adults"],
    insurance: ["Aetna", "Anthem", "Blue Cross Blue Shield", "Humana", "Private Pay"],
    description: "Desert oasis setting providing comprehensive addiction treatment with luxury amenities.",
    rating: 4.7,
    reviews: 198,
    established: "1982",
    accreditation: ["Joint Commission", "NAATP"],
    features: ["Spa Services", "Fitness Center", "Meditation Gardens", "Pet Therapy"]
  },
  {
    id: "3",
    name: "Passages Recovery Center", 
    city: "Malibu",
    state: "CA",
    stateFullName: "California", 
    website: "https://www.passagesmalibu.com",
    phone: "(888) 397-0112",
    email: "admissions@passagesmalibu.com",
    address: "28632 Roadside Drive, Malibu, CA 90265",
    treatmentTypes: ["Residential", "Detox", "Outpatient", "Executive Program"],
    specializations: ["Alcohol Addiction", "Drug Addiction", "Mental Health", "Trauma Therapy"],
    insurance: ["Most PPO Plans", "Private Pay", "Financing Available"],
    description: "Non-12-step luxury rehab facility with holistic healing approach and ocean views.",
    rating: 4.9,
    reviews: 156,
    established: "2001",
    accreditation: ["Joint Commission", "LegitScript"],
    features: ["Ocean Views", "Gourmet Meals", "Holistic Therapies", "1:1 Counseling"]
  },
  {
    id: "4",
    name: "Promises Treatment Centers",
    city: "West Los Angeles", 
    state: "CA",
    stateFullName: "California",
    website: "https://www.promises.com",
    phone: "(844) 876-7463",
    email: "info@promises.com", 
    address: "1851 Purdue Avenue, West Los Angeles, CA 90025",
    treatmentTypes: ["Residential", "PHP", "IOP", "Outpatient"],
    specializations: ["Substance Abuse", "Process Addictions", "Eating Disorders", "Trauma"],
    insurance: ["Aetna", "Anthem", "Cigna", "Magellan", "Private Pay"],
    description: "Evidence-based treatment with celebrity clientele and luxury accommodations.",
    rating: 4.6,
    reviews: 284,
    established: "1988",
    accreditation: ["Joint Commission", "CARF", "NAATP"],
    features: ["Celebrity Privacy", "Luxury Amenities", "Chef-Prepared Meals", "24/7 Nursing"]
  },
  {
    id: "5",
    name: "Cirque Lodge",
    city: "Sundance",
    state: "UT", 
    stateFullName: "Utah",
    website: "https://www.cirquelodge.com",
    phone: "(855) 222-2464",
    email: "admissions@cirquelodge.com",
    address: "777 N Pinebrook Road, Sundance, UT 84604", 
    treatmentTypes: ["Residential", "Detox", "Extended Care", "Alumni Program"],
    specializations: ["Alcohol Addiction", "Drug Addiction", "Co-occurring Disorders", "Executive Treatment"],
    insurance: ["Most Major Insurance", "Private Pay", "Payment Plans"],
    description: "Mountain retreat setting with adventure therapy and evidence-based treatment.",
    rating: 4.8,
    reviews: 167,
    established: "2005",
    accreditation: ["Joint Commission", "NAATP"],
    features: ["Adventure Therapy", "Equine Therapy", "Ski Therapy", "Mountain Views"]
  }
];

export const mockStates = [
  { code: "AL", name: "Alabama", facilities: 8, population: "5,024,279" },
  { code: "AK", name: "Alaska", facilities: 2, population: "733,391" },
  { code: "AZ", name: "Arizona", facilities: 12, population: "7,151,502" },
  { code: "AR", name: "Arkansas", facilities: 6, population: "3,011,524" },
  { code: "CA", name: "California", facilities: 45, population: "39,538,223" },
  { code: "CO", name: "Colorado", facilities: 15, population: "5,773,714" },
  { code: "CT", name: "Connecticut", facilities: 8, population: "3,605,944" },
  { code: "DE", name: "Delaware", facilities: 3, population: "989,948" },
  { code: "FL", name: "Florida", facilities: 32, population: "21,538,187" },
  { code: "GA", name: "Georgia", facilities: 18, population: "10,711,908" },
  { code: "HI", name: "Hawaii", facilities: 4, population: "1,455,271" },
  { code: "ID", name: "Idaho", facilities: 5, population: "1,839,106" },
  { code: "IL", name: "Illinois", facilities: 22, population: "12,812,508" },
  { code: "IN", name: "Indiana", facilities: 14, population: "6,785,528" },
  { code: "IA", name: "Iowa", facilities: 7, population: "3,190,369" },
  { code: "KS", name: "Kansas", facilities: 6, population: "2,937,880" },
  { code: "KY", name: "Kentucky", facilities: 9, population: "4,505,836" },
  { code: "LA", name: "Louisiana", facilities: 11, population: "4,657,757" },
  { code: "ME", name: "Maine", facilities: 5, population: "1,395,722" },
  { code: "MD", name: "Maryland", facilities: 12, population: "6,177,224" },
  { code: "MA", name: "Massachusetts", facilities: 16, population: "7,001,399" },
  { code: "MI", name: "Michigan", facilities: 19, population: "10,037,261" },
  { code: "MN", name: "Minnesota", facilities: 13, population: "5,737,915" },
  { code: "MS", name: "Mississippi", facilities: 7, population: "2,961,279" },
  { code: "MO", name: "Missouri", facilities: 12, population: "6,196,010" },
  { code: "MT", name: "Montana", facilities: 4, population: "1,084,225" },
  { code: "NE", name: "Nebraska", facilities: 5, population: "1,961,504" },
  { code: "NV", name: "Nevada", facilities: 8, population: "3,104,614" },
  { code: "NH", name: "New Hampshire", facilities: 6, population: "1,395,231" },
  { code: "NJ", name: "New Jersey", facilities: 17, population: "9,288,994" },
  { code: "NM", name: "New Mexico", facilities: 6, population: "2,117,522" },
  { code: "NY", name: "New York", facilities: 38, population: "19,336,776" },
  { code: "NC", name: "North Carolina", facilities: 21, population: "10,439,388" },
  { code: "ND", name: "North Dakota", facilities: 3, population: "779,094" },
  { code: "OH", name: "Ohio", facilities: 24, population: "11,799,448" },
  { code: "OK", name: "Oklahoma", facilities: 9, population: "3,959,353" },
  { code: "OR", name: "Oregon", facilities: 11, population: "4,237,256" },
  { code: "PA", name: "Pennsylvania", facilities: 26, population: "13,002,700" },
  { code: "RI", name: "Rhode Island", facilities: 4, population: "1,097,379" },
  { code: "SC", name: "South Carolina", facilities: 12, population: "5,118,425" },
  { code: "SD", name: "South Dakota", facilities: 3, population: "886,667" },
  { code: "TN", name: "Tennessee", facilities: 16, population: "6,910,840" },
  { code: "TX", name: "Texas", facilities: 41, population: "29,145,505" },
  { code: "UT", name: "Utah", facilities: 8, population: "3,271,616" },
  { code: "VT", name: "Vermont", facilities: 3, population: "643,077" },
  { code: "VA", name: "Virginia", facilities: 16, population: "8,631,393" },
  { code: "WA", name: "Washington", facilities: 14, population: "7,705,281" },
  { code: "WV", name: "West Virginia", facilities: 6, population: "1,793,716" },
  { code: "WI", name: "Wisconsin", facilities: 12, population: "5,893,718" },
  { code: "WY", name: "Wyoming", facilities: 2, population: "576,851" }
];

export const mockStatistics = {
  national: {
    totalFacilities: 759,
    peopleInRecovery: "23.5 million",
    overdoseDeaths2023: "107,622",
    treatmentSuccess: "85%"
  },
  byState: {
    "CA": {
      facilities: 45,
      overdoseDeaths: "5,722",
      peopleNeedingTreatment: "2.8 million", 
      helpline: "1-800-662-4357"
    },
    "TX": {
      facilities: 41,
      overdoseDeaths: "5,224", 
      peopleNeedingTreatment: "2.1 million",
      helpline: "1-877-662-8666"
    },
    "FL": {
      facilities: 32,
      overdoseDeaths: "8,238",
      peopleNeedingTreatment: "1.6 million", 
      helpline: "1-844-425-2723"
    },
    "NY": {
      facilities: 38,
      overdoseDeaths: "5,902",
      peopleNeedingTreatment: "1.4 million",
      helpline: "1-800-662-4357"
    }
  }
};

// These option lists must exactly match the real values stored in facility
// documents (backend/populate_from_samhsa.py) - the backend filters with an
// exact-match $in query, not fuzzy matching, so any label here that isn't a
// verbatim string from the real SAMHSA data will silently match zero
// facilities. Pulled from the live distinct values in the database.
export const treatmentTypes = [
  "Outpatient",
  "Regular outpatient treatment",
  "Outpatient methadone/buprenorphine or naltrexone treatment",
  "Intensive outpatient treatment",
  "Residential/24-hour residential",
  "Long-term residential",
  "Short-term residential",
  "Outpatient day treatment or partial hospitalization",
  "Outpatient detoxification",
  "Residential detoxification"
];

export const specializations = [
  "Young Adults",
  "Seniors",
  "Adults",
  "Clients with co-occurring mental and substance use disorders",
  "Clients who have experienced trauma",
  "Adult women",
  "Adult men",
  "Criminal justice (other than DUI/DWI)/Forensic clients",
  "Clients who have experienced intimate partner violence, domestic violence",
  "Clients who have experienced sexual abuse",
  "Children/Adolescents",
  "Young adults",
  "Seniors or older adults",
  "Veterans",
  "Pregnant/postpartum women",
  "Clients with co-occurring pain and substance use disorders",
  "Clients with HIV or AIDS",
  "Members of military families",
  "Active duty military",
  "Adolescents"
];

export const insuranceProviders = [
  "Cash or self-payment",
  "Medicaid",
  "Private health insurance",
  "Medicare",
  "State-financed health insurance plan other than Medicaid",
  "Federal, or any government funding for substance use treatment programs",
  "Federal military insurance (e.g., TRICARE)",
  "SAMHSA funding/block grants",
  "IHS/Tribal/Urban (ITU) funds",
  "No payment accepted"
];